import React from 'react'

import TableRowActions from '@/app/component/layout/table/actions'
import { CommonUserType } from '@/app/module/user/types'

type Props = {
  user: CommonUserType
  isRoleEditable: boolean
  isInvitation: boolean
  isDeleteVisible: boolean

  onManageRole: (user: CommonUserType) => void
  onDeleteInvitation: (userId: number) => void
  onRemoveUser: (user: CommonUserType) => void
}

const UserActionMenu: React.FC<Props> = ({
  user,
  isRoleEditable,
  isInvitation,
  isDeleteVisible,
  onManageRole,
  onDeleteInvitation,
  onRemoveUser,
}) => {
  const config = React.useMemo(() => {
    const actions = []

    if (isRoleEditable) {
      actions.push({
        icon: 'settings',
        label: 'Manage Role & Permissions',
        onClick: () => onManageRole(user),
        tooltip: 'Manage user role & permissions',
      })
    }

    if (isInvitation) {
      actions.push({
        icon: 'delete',
        label: 'Delete Invitation',
        onClick: () => onDeleteInvitation(user.id),
        tooltip: 'Delete invitation',
      })
    }

    if (isDeleteVisible) {
      actions.push({
        icon: 'delete',
        label: 'Remove User',
        onClick: () => onRemoveUser(user),
        tooltip: 'Remove user',
      })
    }

    return actions
  }, [user, isRoleEditable, isInvitation, isDeleteVisible, onManageRole, onDeleteInvitation, onRemoveUser])

  if (!config.length) {
    return null
  }

  return <TableRowActions config={config} />
}

export default UserActionMenu
